import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ReactNode } from "react";

const ChatRouteGuard = ({ children }: { children: ReactNode }) => {
  const { chatId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!chatId) return;

    const isValidUUID =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(chatId);

    if (!isValidUUID) {
      navigate("/", { replace: true });
    }
  }, [chatId, navigate]);

  return <>{children}</>;
};

export default ChatRouteGuard;